import { useSelector } from "react-redux";

import { useMorphedPackActions } from "store/MorphedPackSlice";

const useMorphedPack = () => {
  const { loadMorphedPack } = useMorphedPackActions();
  const { morphedPack } = useSelector((state) => state.MorphedPackSlice);

  return { loadMorphedPack, morphedPack };
};

export default useMorphedPack;
